import Price from '../shop/Price';
import { computeTax, taxableSubtotal } from '../../../utils/tax';

type Props = {
  order: IOrder,
  ignoreShipping?: boolean,
}


const InvoiceReviewTaxes = ({ order, ignoreShipping }: Props) => {
  // Prefer the tax the server actually recorded on the order; only fall
  // back to recomputing from line items when the order carries no server
  // total (e.g. a pre-submit cart-shaped order).
  if (order.tax?.value !== undefined) {
    return <Price price={order.tax.value} showZero />;
  }
  const items = order.items;
  const subtotal = items.filter(item => !item.item.name.startsWith("Shipping")).reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);
  const shipping = items.filter(item => item.item.name.startsWith("Shipping")).reduce((subtotal, item) => subtotal + (item.count * (item.item.price ? item.item.price : 0)), 0);
  // Shipping lines are always taxable; only catalog lines can be exempt.
  const taxable = taxableSubtotal(
    items.filter(item => !item.item.name.startsWith("Shipping")),
  );

  const taxes = computeTax(
    taxable + shipping,
    subtotal + shipping,
    order.discountAmount ?? 0,
  );

  return (
    <Price price={taxes}/>
  )
}

export default InvoiceReviewTaxes